export const relatedQuestionsData = ({ chapterDetailsReducer: { relatedQuestions } }) =>
	relatedQuestions;
